import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CommunitySidebar from "../components/community/CommunitySidebar";
import CommunityRightRail from "../components/community/CommunityRightRail";

export default function SupportPage() {
  const navigate = useNavigate();

  // 사이드바에서 다른 카테고리 선택 시 커뮤니티 피드로 이동
  const handleSelectCategory = (catId, subId) => {
    const params = new URLSearchParams();
    if (catId) params.set("cat", catId);
    if (subId) params.set("sub", subId);
    navigate(`/community?${params.toString()}`);
  };

  return (
    <div className="min-h-screen bg-[#F4F2EE] pt-20 pb-32" data-testid="support-page">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="flex gap-5 items-start">
          {/* === Left Sidebar (커뮤니티와 동일) === */}
          <div className="hidden lg:block sticky top-20 self-start max-h-[calc(100vh-5.5rem)] overflow-y-auto pr-1 scrollbar-thin">
            <CommunitySidebar
              activeCategory="contact"
              onSelectCategory={handleSelectCategory}
            />
          </div>

          {/* === Main Content === */}
          <main className="flex-1 min-w-0 max-w-2xl mx-auto lg:mx-0">
            <div className="px-1 mb-3">
              <h1 className="font-serif text-2xl sm:text-3xl text-stone-900 tracking-tight" data-testid="support-heading">
                고객센터
              </h1>
              <p className="text-sm text-stone-500 mt-1">도움이 필요하시면 아래 연락처로 문의해주세요.</p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-white rounded-2xl border border-stone-100 p-5 shadow-[0_1px_3px_rgba(0,0,0,0.02)]">
                <Phone className="w-5 h-5 text-burgundy-500 mb-3" />
                <h3 className="font-bold text-stone-800 text-sm mb-2">전화 문의</h3>
                <p className="text-sm text-stone-600">캐나다: 1-647-292-3959</p>
                <p className="text-sm text-stone-600">서울: 010-9474-3959</p>
              </div>
              <div className="bg-white rounded-2xl border border-stone-100 p-5 shadow-[0_1px_3px_rgba(0,0,0,0.02)]">
                <Mail className="w-5 h-5 text-burgundy-500 mb-3" />
                <h3 className="font-bold text-stone-800 text-sm mb-2">이메일 문의</h3>
                <p className="text-sm text-stone-600">contact@newcoupling.com</p>
                <p className="text-xs text-stone-400 mt-1">영업일 기준 24시간 내 답변</p>
              </div>
              <div className="bg-white rounded-2xl border border-stone-100 p-5 shadow-[0_1px_3px_rgba(0,0,0,0.02)]">
                <MapPin className="w-5 h-5 text-burgundy-500 mb-3" />
                <h3 className="font-bold text-stone-800 text-sm mb-2">오피스</h3>
                <p className="text-sm text-stone-600">캐나다: 78 Westhampton Dr. Thornhill ON. L4J7J7</p>
                <p className="text-sm text-stone-600">서울: 서초구 강남대로 305, b117-01호(서초동)</p>
              </div>
              <div className="bg-white rounded-2xl border border-stone-100 p-5 shadow-[0_1px_3px_rgba(0,0,0,0.02)]">
                <Clock className="w-5 h-5 text-burgundy-500 mb-3" />
                <h3 className="font-bold text-stone-800 text-sm mb-2">운영 시간</h3>
                <p className="text-sm text-stone-600">월~금: 오전 10시 ~ 오후 6시 (KST)</p>
                <p className="text-sm text-stone-600">토/일/공휴일: 이메일 접수만 가능</p>
              </div>
            </div>
          </main>

          {/* === Right Rail (커뮤니티와 동일) === */}
          <div className="hidden xl:block sticky top-20 self-start max-h-[calc(100vh-5.5rem)] overflow-y-auto pr-1 scrollbar-thin">
            <CommunityRightRail />
          </div>
        </div>
      </div>
    </div>
  );
}
